import React, { Component } from 'react'
import { func } from 'prop-types'
import { translate } from 'react-i18next'
import { Loader } from '../../components/ui/states/Loader'
import { NoInquiries } from '../../components/ui/states/NoInquiries'
import { stores, view } from '../../stores'
import { InquiryListItem } from '../../components/inquiries/InquiryListItem'
import { SubHero } from '../../components/header/SubHero'
import { NewInquiryButton } from '../../components/ui/buttons/NewInquiryButton'
import './InquiriesListPage.css'

class InquiriesListPageComponent extends Component {
  async componentDidMount () {
    await stores.inquiries.getList()
  }

  render () {
    const { t } = this.props

    if (stores.inquiries.loading) {
      return (<Loader />)
    }

    if (!stores.inquiries.list || !stores.inquiries.list.length) {
      return (<NoInquiries />)
    }

    return (
      <div>
        <SubHero breadcrumb={[{ name: t('common:visits:my_requests') }]} />
        <div className='demandes layout__container'>
          <div className='demandes__header'>
            <h1 className='main-title demandes__title'>{t('common:visits:my_requests')}</h1>
            <NewInquiryButton />
          </div>
          {
            stores.inquiries.list.map((request) => <InquiryListItem key={`item-${request.id}`} request={request} />)
          }
        </div>
      </div>
    )
  }
}

InquiriesListPageComponent.propTypes = {
  t: func
}

export const InquiriesListPage = translate()(view(InquiriesListPageComponent))



// WEBPACK FOOTER //
// ./src/pages/demandes/InquiriesListPage.js